// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_eh-0";
export var fileCarousel = "_eh-2";
export var removeFileButton = "_eh-1";